import { Controller } from '@hotwired/stimulus'

export default class NestedFormController extends Controller {
  static targets = ['addLink', 'removeLink', 'template', 'counter', 'fieldsWrapper'];

  connect() {
    this.refreshCounters();
  }

  addAssociation(event) {
    event.preventDefault();

    this.add(this.templateTarget);
  }

  add(element) {
    // child_index must be unique in nested form. Replacing template child index "NEW_RECORD"
    // with a unique timestamp
    const content = element.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());

    this.addLinkTarget.insertAdjacentHTML('beforebegin', content);

    this.refreshCounters();

    const fieldsWrapperArray = Array.from(
      this.element.querySelectorAll('div[data-nested-form-target=fieldsWrapper]')
    );
    // Trigger event on window with fieldset in payload so that after add logic
    // can be done in other controller
    const trigger = new CustomEvent('nestedElementAdded', {
      detail: {
        fieldset: fieldsWrapperArray.pop(),
        previousFieldset: fieldsWrapperArray.pop()
      },
    });

    window.dispatchEvent(trigger);
  }

  duplicateAssociation(event) {
    event.preventDefault();

    const fieldsWrapper = event.currentTarget.closest('[data-nested-form-target=fieldsWrapper]');

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());

    fieldsWrapper.insertAdjacentHTML('afterend', content);

    const duplicatedFieldsWrapper = fieldsWrapper.nextElementSibling;

    const duplicatedFieldsWrapperInputs = Array.from(
      duplicatedFieldsWrapper.querySelectorAll('input:not([readonly=readonly]):not([type="hidden"])')
    );

    // Loop on every editable inputs
    duplicatedFieldsWrapperInputs.forEach((input, _) => {
      // input.name = loan[borrower_terms_attributes][1744903150450][due_on]
      // splittedElements ['loan', 'borrower_terms_attributes', '1744903150450', 'due_on']
      let splittedElements = input.name.split(/\[|\]/).filter(Boolean);
      let attributeName = splittedElements.pop();

      if (attributeName === 'due_on') {
        return;
      }

      if (input.type === 'checkbox') {
        input.checked = fieldsWrapper.querySelector(`input[id*='_${attributeName}']`).checked;
      } else {
        input.value = fieldsWrapper.querySelector(`input[id*='_${attributeName}']`).value;
      }
    });

    duplicatedFieldsWrapper.querySelector('input[id*=\'_id\']').value = null;

    this.refreshCounters();

    const trigger = new CustomEvent('nestedElementDuplicated');

    window.dispatchEvent(trigger);
  }

  removeAssociation(event) {
    event.preventDefault();

    const fieldsWrapper = event.currentTarget.closest('[data-nested-form-target=fieldsWrapper]');

    this._remove(fieldsWrapper);

    this.refreshCounters();

    const trigger = new CustomEvent('nestedElementRemoved');
    window.dispatchEvent(trigger);
  }

  refreshCounters() {
    this.counterTargets.filter((counter) => {
      return counter.closest('[data-nested-form-target=fieldsWrapper]').style.display !== 'none';
    }).forEach((counter, i) => {
      counter.innerText = `${counter.dataset.text} ${i + 1}`;
    });
  }

  reset() {
    this.fieldsWrapperTargets.forEach((fieldsWrapper) => {
      this._remove(fieldsWrapper);
    });

    this.refreshCounters();

    const trigger = new CustomEvent('nestedElementRemoved');
    window.dispatchEvent(trigger);
  }

  _remove(elem) {
    if (elem.dataset.newRecord === 'true') {
      elem.remove();
    } else {
      elem.querySelector("input[name*='_destroy']").value = 1;
      elem.dataset.destroyed = 'true';
      elem.style.display = 'none';
    }
  }

  _countNestedFields() {
    return this.fieldsWrapperTargets.length;
  }
}
